/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Appbar_Search_Placeholder1Inputs */

const en_appbar_search_placeholder1 = /** @type {(inputs: Appbar_Search_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search...`)
};

const de_appbar_search_placeholder1 = /** @type {(inputs: Appbar_Search_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchen...`)
};

/**
* | output |
* | --- |
* | "Search..." |
*
* @param {Appbar_Search_Placeholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const appbar_search_placeholder1 = /** @type {((inputs?: Appbar_Search_Placeholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Appbar_Search_Placeholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_appbar_search_placeholder1(inputs)
	return de_appbar_search_placeholder1(inputs)
});
export { appbar_search_placeholder1 as "appBar_search_placeholder" }